import { render } from "./DataJDIH.vue?vue&type=template&id=16acf56c"
import script from "./DataJDIH.vue?vue&type=script&lang=js"
export * from "./DataJDIH.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__